import React from "react";
import Text from "../../../../components/ui/Text";
import xImage from "../../assets/x.png";

interface Props {
  className?: string;
  description?: string;
  titleWords?: { word: string; isHighlighted?: boolean }[];
  onClose?: () => void;
}

const ElectricianHeader = ({
  className = "",
  titleWords = [
    { word: "ELECTRICAL", isHighlighted: false },
    { word: "SYSTEM", isHighlighted: true },
  ],
  description = "Rotate the pipe tiles to form a continuous circuit from START to END before time runs out.",
  onClose,
}: Props) => {
  return (
    <div
      className={`rounded-[6px] p-3 px-5 w-full flex items-center justify-between bg-gradient-to-r from-[#242939]/30 via-[#596070]/80 to-[#242939]/30 ${className}`}
    >
      <div className="flex items-center justify-between space-x-10 w-full">
        {/* Left */}
        <div className="">
          <div className="flex items-center space-x-2">
            {/* Lightning bolt icon */}
            <div className="w-[35px] h-[26px] flex items-center justify-center mr-2 flex-shrink-0">
              <svg
                viewBox="0 0 24 24"
                width="28"
                height="28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 2L4.5 13.5H11L10 22L20.5 10H14L13 2Z"
                  fill="#facc15"
                  stroke="#f59e0b"
                  strokeWidth="1.2"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            {titleWords.map(({ word, isHighlighted }, i) => (
              <Text
                size="2xl"
                key={i}
                style={{
                  textShadow: isHighlighted
                    ? "-8px -5px 8px rgba(250, 204, 21, 0.35)"
                    : "auto",
                }}
                className={`relative bebas-neue-font !font-[500] ${
                  isHighlighted ? "text-[#facc15]" : "text-white"
                }`}
              >
                {word}
              </Text>
            ))}
          </div>
          <Text
            size="xxs"
            className="text-white/50 font-gilroy max-w-[320px] leading-[1.2]"
          >
            {description}
          </Text>
        </div>

        {/* Right — close button */}
        {onClose && (
          <button
            title="Close"
            onClick={onClose}
            className="bg-[#A42A2A]/30 rounded-md active:scale-95 transition hover:opacity-70 border-[1px] border-[#DD3030] p-3 flex-shrink-0"
          >
            <img src={xImage} alt="X" className="w-[18px] h-[18px]" />
          </button>
        )}
      </div>
    </div>
  );
};

export default React.memo(ElectricianHeader);
